var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('apexchart',{attrs:{"type":"bar","height":"400","width":"1200","options":_vm.chartOptions,"series":_vm.series}})],1),_c('div',{staticClass:"col-md-5"},[_c('apexchart',{attrs:{"height":"300","type":"donut","options":_vm.chartOptions2,"series":_vm.series2}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }